export default __webpack_public_path__ + "static/media/existinguser.4a4d7c21.svg";